import Modal from 'react-modal';
import styled from 'styled-components';
import images from '../../../images';
import { __ } from '../../../locales';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '75%',
    paddingBottom: 10,
    borderRadius: 15,
    border: 'none'
  }
};

const RestartButton = styled.button`
  margin-bottom: 5px;
  margin-top: 5px;
  width: 96%;
  justify-content: center;
  align-items: center;
  background-color: #00008B;
  color: white;
  position: relative;
  zIndex: 100;
`;

const ContinueButton = styled.button`
  margin-top: 5px;
  width: 96%;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #00008B;
  position: relative;
  zIndex: 100;
`;

const TimeOutText = styled.h2`
  margin-top: 13%;
  font-size: 30px;
  text-align: center;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const TimeOutContext = styled.h2`
  margin-bottom: 10%;
  font-size: 16px;
`;

const TimeOutImage = styled.img`
  height: 90%;
  margin-right: 3%;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const CloseImage = styled.img`
  height: ${window.innerWidth / 20}px;
  width: ${window.innerWidth / 20}px;
  border-radius: 50%;
  margin-top: 2%;
  margin-left: 8%;
  margin-right: 92%;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  align-self: flex-end;
  padding: 0 20px;
`;

/**
 * This compoent is a modal two show time out when user didn't answer a question in 5 seconds
 *
 */

const TimeOutModal = ({
  onClose,
  onRestart
}) => {
  const modalIsOpen = true;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      overlayClassName="signup-modal-overlay"
    >
      <CloseButton accessibilityLabel="Close" onClick={onClose}>
        <CloseImage src={images.close} alt="Close" />
      </CloseButton>
      <TimeOutText>
        {__('app.oops')}
      </TimeOutText>
      <TimeOutContext role="alert">
        {__('app.times_out')}
      </TimeOutContext>
      <TimeOutImage
        src={images.time_out}
        alt="Time out illustration"
      />
      <RestartButton onClick={onRestart}>
        {__('app.restart')}
      </RestartButton>
      <ContinueButton onClick={onClose}>
        {__('app.continue')}
      </ContinueButton>
    </Modal>
  );
};

export default TimeOutModal;
